import React from "react";
import { withStyles } from "@material-ui/styles";
import { Tab, Tabs } from "@material-ui/core";
import { useHistory, useRouteMatch } from "react-router-dom";

import theme from "../../Theme";

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&:focus": {
      color: theme.palette.secondary.main,
    },
    zIndex: 1,
  },
  selected: {
    color: theme.palette.secondary.main,
  },
}))((props) => <Tab disableRipple {...props} />);

const StyledTabs = withStyles({
  root: {
    borderRadius: 56,
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span > div": {
      maxWidth: 40,
      height: 40,
      width: "100%",
      backgroundColor: "#635ee7",
    },
  },
})((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: (
        <div
          style={{
            margin: "10px 20px",
            width: "calc(100% - 40px)",
            height: "calc(100% - 20px)",
            borderRadius: "48px",
            backgroundColor: theme.palette.primary.main,
            zIndex: 0,
          }}
        />
      ),
      style: {
        height: "100%",
      },
    }}
  />
));

function TabHeader({
  children,
  index,
  full,
  style,
  setSubpage,
  currentSubpage,
  url,
}) {
  const [value, setValue] = React.useState(currentSubpage);

  let history = useHistory();
  let { path } = useRouteMatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setTimeout(() => {
      setSubpage(newValue);
      window.scrollTo(0, 0);

      if (newValue === 0) {
        history.push(`${url}/overview`);
      } else if (newValue === 1) {
        history.push(`${url}/reviews`);
      } else if (newValue === 2) {
        history.push(`${url}/benefits`);
      }
    }, 300);
  };

  const tabStyle = { textTransform: "initial" };
  let variantValue = "";
  let tabsStyle = {
    backgroundColor: "white",
    zIndex: "100000",
    boxShadow: "none",
  };

  if (full) {
    variantValue = "fullWidth";
    tabsStyle = {
      ...tabsStyle,
    };
  } else {
    tabStyle.minHeight = "65px";
    tabStyle.fontSize = "18px";
    tabStyle.width = "200px";
  }

  return (
    <StyledTabs
      value={value}
      onChange={handleChange}
      variant={variantValue}
      style={tabsStyle}
    >
      <StyledTab label="Overview" style={tabStyle} index={0} />
      {/* <StyledTab label="Stats" style={tabStyle} index={1} /> */}
      <StyledTab label="Reviews" style={tabStyle} index={1} />
      {/* <StyledTab label="Benefits" style={tabStyle} index={2} /> */}
    </StyledTabs>
  );
}

export default TabHeader;
